import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"bell\"><g stroke=\"#010F2F\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\"><path d=\"M16 7A6 6 0 1 0 4 7c0 7-3 9-3 9h18s-3-2-3-9M11.73 20a2 2 0 0 1-3.46 0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol